import { render } from "./InstructionBitrix24Page.vue?vue&type=template&id=cb6c5800&scoped=true"
import script from "./InstructionBitrix24Page.vue?vue&type=script&lang=js"
export * from "./InstructionBitrix24Page.vue?vue&type=script&lang=js"

import "./InstructionBitrix24Page.vue?vue&type=style&index=0&id=cb6c5800&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb6c5800"]])

export default __exports__